import React, { useRef } from 'react';
import './ContentComponent.css'

const ContentComponent = () => {
    const videoRef = useRef(null);

return (
<div className="content">
    <video
        className='content-video'
        autoPlay
        loop
        playsInline
        muted
        id="mobile_home_video"
        ref={videoRef}>
        <source type="video/webm" src="https://d5l8cb2ud43ux.cloudfront.net/IMG_2810_2.webm"/>
        <source type="video/mp4" src="https://d5l8cb2ud43ux.cloudfront.net/IMG_2810_2.mp4"/>
    </video>
    <img src='/assets/images/mainoverlay.png' alt="תמונות בהדבקה" />
</div>

    );
};

export default ContentComponent;
